import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MediaAttachment, MediaType } from '../../models/MediaAttachment';
import { UploadItem } from '../../models/upload-item.interface';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'app-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, MatProgressBarModule]
})

export class AttachmentDialogComponent {
  uploadQueue: UploadItem[] = [];
  uploadedFiles: MediaAttachment[] = [];
  uploading = false;
  enumMediaType = MediaType;

  constructor(
    private _http: HttpClient,
    private _mediaService: MediaService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AttachmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { type: MediaType, accessToken : string }
  ) {}

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      Array.from(input.files).forEach((file) => {
        const item: UploadItem = { file, progress: 0 };
        if (this.dialogData.type === MediaType.image || this.dialogData.type === MediaType.video) {
          const reader = new FileReader();
          reader.onload = () => (item.previewUrl = reader.result as string);
          reader.readAsDataURL(file);
        }
        this.uploadQueue.push(item); //TODO:ignor push if same file selected again

        //TODO:ignor upload if same file selected again
        const sub = this._mediaService.uploadFile(file, this.dialogData.accessToken, this.dialogData.type)
          .subscribe({
            next: ({ progress, result }) => {
              item.progress = progress;
              if (result) {
                item.uploadResult = result;
                this.uploadedFiles.push(result);
                this._snackBar.open(`Uploaded: ${file.name}`, 'OK', { duration: 2000 });
              }
            },
            error: (err) => {
              console.error('Upload failed', err);
              this._snackBar.open(`Failed: ${file.name}`, 'Close', { duration: 3000 });
            }
          });

        item.uploadSub = sub;
      });
    }
  }

  //TODO
  cancelUpload(item: UploadItem) {
    if (item.uploadSub) {
      item.uploadSub.unsubscribe(); // stop active upload
    }
    this.uploadQueue = this.uploadQueue.filter(q => q !== item);
  }

  onSend(newMessage: string) {
    var result = {
      newMessage: newMessage,
      uploadedFiles: this.uploadedFiles
    }
    this.dialogRef.close(result);
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}